/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { connect } from 'react-redux';
import videojs from 'video.js';
// @ts-ignore
import seekButtons from 'videojs-seek-buttons';
import { exchangeVideoJsOptions } from './exchangeVideoJsOptions';
import { IAppState } from '../../../../../state/reducers';
import { IProps, IStateProps } from './interfaces';
import { selectActiveAssetDetails } from '../../../../../state/exchange/searchResults';

class ExchangeVideoPlayer extends React.Component<IProps> {
  private player?: videojs.Player;

  setSource = () => {
    const { source } = this.props;

    this.player.src({
      src: source,
    });
  };

  componentDidMount() {
    this.player = videojs('exchange-asset-preview', exchangeVideoJsOptions);

    videojs.log.level('off');

    // @ts-ignore
    this.player.seekButtons({
      forward: 15,
      back: 15,
    });

    const playToggleButton = this.player.controlBar.getChild('PlayToggle');

    this.player.controlBar.on('mousedown', (e) => {
      e.preventDefault();
      playToggleButton.focus();
    });

    this.setSource();
  }

  componentDidUpdate(prevProps: IProps) {
    const { source } = this.props;

    if (prevProps.source !== source) {
      this.setSource();
    }
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
  }

  render() {
    return (
      <div>
        <video
          id="exchange-asset-preview"
          className="video-js vjs-16-9 vjs-big-play-centered"
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  source: state.exchange?.activeAsset?.mediaInformation?.source ?? '',
  activeAssetDetails: selectActiveAssetDetails(state),
});

export default connect(
  mapStateToProps,
)(ExchangeVideoPlayer);
